<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<reporting-sidenav></reporting-sidenav>

			<div id="content" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light b-b">
					<a class="flex navbar-brand">
						School Dashboard
						<template v-if="school && schoolMode">
							<span class="far fa-fw fa-angle-right"></span>
							{{ school.name }}
						</template>
					</a>
				</div>

				<div class="content-main">
					<div class="row mx-0 no-grow px-2 pt-3 b-b box mb-0" v-if="districtMode || allMode">
						<div class="flex d-flex flex-row flex-wrap">
							<div class="col-12 col-sm-6 d-flex align-items-center pb-3" v-if="allMode">
								<label class="no-grow mb-0 mr-3" style="width: 50px;">District:</label>
								<div class="flex">
									<config-select
										:options="districts"
										v-model="sDistrict"
										style="max-width: 300px"
									></config-select>
								</div>
							</div>
							<div class="col-12 col-sm-6 d-flex align-items-center pb-3">
								<label class="no-grow mb-0 mr-3" style="width: 50px;">School:</label>
								<div class="flex">
									<config-select
										:options="schools"
										v-model="sSchool"
										style="max-width: 300px"
									></config-select>
								</div>
							</div>
						</div>
					</div>
					<div v-if="districtID && schoolID" class="padding">
						<div class="row">
							<div class="col-12 col-xl-12">
								<school-dash-scores :districtID="districtID" :schoolID="schoolID" />
							</div>
							<!--	<div class="col-12 col-xl-4">
								<school-dash-completion :districtID="districtID" :schoolID="schoolID" />
							</div>
							<div class="col-12 col-xl-4">
								<school-dash-score-volume :districtID="districtID" :schoolID="schoolID" />
							</div> -->
						</div>
						<div class="row">
							<div class="col-12">
								<school-dash-progress :districtID="districtID" :schoolID="schoolID" />
							</div>
						</div>
					</div>
					<template v-if="!(districtID && schoolID)">
						<h1 v-if="districtMode" class="text-extra-muted text-center my-5">Please choose a school</h1>
						<h1 v-if="allMode" class="text-extra-muted text-center my-5">
							Please choose a district/school
						</h1>
					</template>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-main {
	background-color: #f3f6f9;
}
@media (max-width: 575px) {
	.btn-container {
		width: 20px;
	}
}
div.btn-subtle {
	opacity: 0.7;
}
a.btn-subtle {
	opacity: 0.7;
	transition: opacity 0.25s;
}
a.btn-subtle:hover {
	opacity: 1;
}
</style>

<script>
import $ from "jquery";
import _ from "lodash";
import DistrictService from "@/services/DistrictService";
import SchoolService from "@/services/SchoolService";
import Notie from "@/services/NotieService";
import store from "@/services/Store";

import ConfigSelect from "@/components/ConfigSelect";
import SchoolDashScores from "@/components/school_dashboard/SchoolDashScores";
import SchoolDashCompletion from "@/components/school_dashboard/SchoolDashCompletion";
import SchoolDashScoreVolume from "@/components/school_dashboard/SchoolDashScoreVolume";
import SchoolDashProgress from "@/components/school_dashboard/SchoolDashProgress";

export default {
	name: "SchoolDashboard",
	props: ["user"],
	data() {
		return {
			districtID: null,
			schoolID: null,
			school: null,

			districts: [],
			sDistrict: null,
			schools: [],
			sSchool: null
		};
	},
	components: {
		ConfigSelect,
		SchoolDashScores,
		SchoolDashCompletion,
		SchoolDashScoreVolume,
		SchoolDashProgress
	},
	computed: {
		schoolMode() {
			return this.user.role.school_dash_access_level == 0;
		},
		districtMode() {
			return this.user.role.school_dash_access_level == 1;
		},
		allMode() {
			return this.user.role.school_dash_access_level == 2;
		}
	},
	watch: {
		sDistrict() {
			if (this.sDistrict) {
				this.districtID = this.sDistrict.id;
				store.set(this, "dash.school.districtID", this.districtID);
				if (this.allMode) {
					this.loadSchools();
				}
			}
		},
		sSchool() {
			if (this.sSchool) {
				this.schoolID = this.sSchool.id;
				store.set(this, "dash.school.schoolID", this.schoolID);
			}
		}
	},
	created() {
		if (this.allMode) this.loadAllMode();
		else if (this.districtMode) this.loadDistrictMode();
		else if (this.schoolMode) this.loadSchoolMode();
	},
	mounted() {},
	methods: {
		loadSchoolMode() {
			this.districtID = this.user.district_id;
			this.schoolID = this.user.school_id;

			SchoolService.getSchool(this.schoolID)
				.then(r => {
					this.school = r.data;
				})
				.catch(e => {
					console.log(e);
					Notie.error("Failed to get school name", e);
				});
		},

		loadDistrictMode() {
			this.districtID = this.user.district_id;

			this.loadSchools();
		},

		loadAllMode() {
			DistrictService.listDistricts().then(r => {
				this.districts = r.data.districts;

				let districtID = store.getDefault(this, "dash.school.districtID", null);
				let savedDistrict = _.find(this.districts, { id: districtID });
				if (savedDistrict) {
					this.sDistrict = savedDistrict;
				}
			});
		},

		loadSchools() {
			SchoolService.listSchools({ district_id: this.districtID }).then(r => {
				this.schools = r.data.schools;

				let schoolID = store.getDefault(this, "dash.school.schoolID", null);
				let savedSchool = _.find(this.schools, { id: schoolID });
				if (savedSchool) {
					this.sSchool = savedSchool;
				}
			});
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/vues/Landing/SchoolDashboard.vue